import {
  getRequest,
  postRequest,
  deleteRequest
} from 'utils/http'

export const getMyIntegrationsApi = () =>
  getRequest('/integrations')

export const getProvidersApi = () =>
  getRequest('/integrations/providers')

export const connectIntegrationApi = ({
  provider,
  credentials
}) => postRequest(`/integrations/${provider}`, { credentials })

export const disconnectIntegrationApi = provider =>
  deleteRequest(`/integrations/${provider}`)

export const getUserIntegrationsApi = userId =>
  getRequest(`/integrations/user/${userId}`)

// Returns { authorizeUrl } that the frontend redirects to.
export const startOAuthApi = providerKey =>
  getRequest(`/integrations/${providerKey}/oauth/start`)
